// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssetViewerController from "./asset_viewer_controller"
application.register("asset-viewer", AssetViewerController)


application.register("quick-add", QuickAddController)
application.register("contact-quick-add", QuickAddController)
application.register("partner-quick-add", QuickAddController)

import CodesModalController from "./codes_modal_controller"
application.register("codes-modal", CodesModalController)

import CtaTypeController from "./cta_type_controller"
application.register("cta-type", CtaTypeController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ListController from "./list_controller"
application.register("list", ListController)

import LocaleTabsController from "./locale_tabs_controller"
application.register("locale-tabs", LocaleTabsController)

import MediaPickerController from "./media_picker_controller"
application.register("media-picker", MediaPickerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import QuickAddController from "./quick_add_controller"
application.register("quick-add", QuickAddController)

import RevertController from "./revert_controller"
application.register("revert", RevertController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
